import { AlertTriangle, Check } from 'lucide-react';

import { Badge } from '@apps/web/components/ui/badge';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';
import { cn } from '@apps/web/lib/utils';
import { type CaregiverComplianceStatus } from '@libraries/typescript/api_client';

type CaregiverComplianceBadgeProps = {
    readonly compliance: CaregiverComplianceStatus;
    readonly className?: string;
};

export function CaregiverComplianceBadge({
    compliance,
    className,
}: CaregiverComplianceBadgeProps) {
    const isNonCompliant = compliance.state === 'non_compliant';
    const label = compliance.label;

    return (
        <Tooltip>
            <TooltipTrigger asChild={true}>
                <Badge
                    asChild={true}
                    variant={isNonCompliant ? 'warning' : 'success'}
                >
                    <button
                        type="button"
                        aria-label={`${label}. ${compliance.tooltip}`}
                        className={cn('max-w-48 cursor-help', className)}
                        onClick={(event) => event.stopPropagation()}
                    >
                        {isNonCompliant ? (
                            <AlertTriangle
                                aria-hidden="true"
                                data-testid="caregiver-compliance-warning-icon"
                            />
                        ) : (
                            <Check aria-hidden="true" />
                        )}
                        <span className="truncate">{label}</span>
                    </button>
                </Badge>
            </TooltipTrigger>
            <TooltipContent
                side="bottom"
                align="start"
                sideOffset={6}
                className="max-w-xs whitespace-pre-line"
            >
                {compliance.tooltip}
            </TooltipContent>
        </Tooltip>
    );
}
